import SearchLandingAbstract from '@pp-frontend/shared-packages/classes/landing/SearchLandingAbstract'
import { IdentityDoc } from '@pp-frontend/shared-packages/types/dto/IdentityDoc'
import { AxiosResponse } from 'axios'

export default class extends SearchLandingAbstract {
  requestBody (): IdentityDoc {
    return {
      // @ts-ignore
      licence_plate: window.$nuxt.context.query.document_value as string
    }
  }

  validate (formData): Promise<AxiosResponse> {
    const validationUrl = process.env.API_ENDPOINT + 'gibdd/search-grz-validate'
    return window.$nuxt.$axios.post<IdentityDoc[], AxiosResponse<IdentityDoc[]>>(validationUrl, {
      licence_plate: formData.document_value
    }, {
      params: this.requestParams(),
      timeout: 30_000
    })
  }

  endpointUrl (): string {
    return process.env.API_ENDPOINT + 'gibdd/search-grz'
  }
}
